/**
 * belfastpilates-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesDevelopmentappspotcom) {
      root.BelfastpilatesDevelopmentappspotcom = {};
    }
    root.BelfastpilatesDevelopmentappspotcom.LoginRequest = factory(root.BelfastpilatesDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The LoginRequest model module.
   * @module model/LoginRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LoginRequest</code>.
   * @alias module:model/LoginRequest
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>LoginRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LoginRequest} obj Optional instance to populate.
   * @return {module:model/LoginRequest} The populated <code>LoginRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('authenticateProvider')) {
        obj['authenticateProvider'] = ApiClient.convertToType(data['authenticateProvider'], 'String');
      }
      if (data.hasOwnProperty('businessOpeningHours')) {
        obj['businessOpeningHours'] = ApiClient.convertToType(data['businessOpeningHours'], 'String');
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('facebookId')) {
        obj['facebookId'] = ApiClient.convertToType(data['facebookId'], 'String');
      }
      if (data.hasOwnProperty('firstName')) {
        obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
      }
      if (data.hasOwnProperty('languageId')) {
        obj['languageId'] = ApiClient.convertToType(data['languageId'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('level')) {
        obj['level'] = ApiClient.convertToType(data['level'], ['String']);
      }
      if (data.hasOwnProperty('levelOptions')) {
        obj['levelOptions'] = ApiClient.convertToType(data['levelOptions'], ['String']);
      }
      if (data.hasOwnProperty('limitOnSwaps')) {
        obj['limitOnSwaps'] = ApiClient.convertToType(data['limitOnSwaps'], 'Number');
      }
      if (data.hasOwnProperty('loginMessage')) {
        obj['loginMessage'] = ApiClient.convertToType(data['loginMessage'], 'String');
      }
      if (data.hasOwnProperty('platform')) {
        obj['platform'] = ApiClient.convertToType(data['platform'], 'String');
      }
      if (data.hasOwnProperty('roleType')) {
        obj['roleType'] = ApiClient.convertToType(data['roleType'], 'String');
      }
      if (data.hasOwnProperty('socialSource')) {
        obj['socialSource'] = ApiClient.convertToType(data['socialSource'], 'String');
      }
      if (data.hasOwnProperty('source')) {
        obj['source'] = ApiClient.convertToType(data['source'], 'String');
      }
      if (data.hasOwnProperty('stripePublishKey')) {
        obj['stripePublishKey'] = ApiClient.convertToType(data['stripePublishKey'], 'String');
      }
      if (data.hasOwnProperty('surname')) {
        obj['surname'] = ApiClient.convertToType(data['surname'], 'String');
      }
      if (data.hasOwnProperty('twitterId')) {
        obj['twitterId'] = ApiClient.convertToType(data['twitterId'], 'String');
      }
      if (data.hasOwnProperty('userEmail')) {
        obj['userEmail'] = ApiClient.convertToType(data['userEmail'], 'String');
      }
      if (data.hasOwnProperty('userName')) {
        obj['userName'] = ApiClient.convertToType(data['userName'], 'String');
      }
      if (data.hasOwnProperty('version')) {
        obj['version'] = ApiClient.convertToType(data['version'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} authenticateProvider
   */
  exports.prototype['authenticateProvider'] = undefined;
  /**
   * @member {String} businessOpeningHours
   */
  exports.prototype['businessOpeningHours'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} facebookId
   */
  exports.prototype['facebookId'] = undefined;
  /**
   * @member {String} firstName
   */
  exports.prototype['firstName'] = undefined;
  /**
   * @member {String} languageId
   */
  exports.prototype['languageId'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {Array.<String>} level
   */
  exports.prototype['level'] = undefined;
  /**
   * @member {Array.<String>} levelOptions
   */
  exports.prototype['levelOptions'] = undefined;
  /**
   * @member {Number} limitOnSwaps
   */
  exports.prototype['limitOnSwaps'] = undefined;
  /**
   * @member {String} loginMessage
   */
  exports.prototype['loginMessage'] = undefined;
  /**
   * @member {String} platform
   */
  exports.prototype['platform'] = undefined;
  /**
   * @member {String} roleType
   */
  exports.prototype['roleType'] = undefined;
  /**
   * @member {String} socialSource
   */
  exports.prototype['socialSource'] = undefined;
  /**
   * @member {String} source
   */
  exports.prototype['source'] = undefined;
  /**
   * @member {String} stripePublishKey
   */
  exports.prototype['stripePublishKey'] = undefined;
  /**
   * @member {String} surname
   */
  exports.prototype['surname'] = undefined;
  /**
   * @member {String} twitterId
   */
  exports.prototype['twitterId'] = undefined;
  /**
   * @member {String} userEmail
   */
  exports.prototype['userEmail'] = undefined;
  /**
   * @member {String} userName
   */
  exports.prototype['userName'] = undefined;
  /**
   * @member {String} version
   */
  exports.prototype['version'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/LoginRequest.js